<crud-list class="block-100" [data]="table" [detailUrl]="'/enaio-certificates/class-registers/course/' + year + '/'" restUrl="api/cer/classregister/course" (onDelete)="initParams()">
    <ng-template #toolbarTemplate>
        <p-checkbox appLabel="Ausgelaufene Kurse anzeigen" class="ml-3 option" name="showFinishedCourses" [(ngModel)]="showFinishedCourses" [binary]=true (ngModelChange)="updateTable()"></p-checkbox>
    </ng-template> 
</crud-list>
